import {
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
} from '@mui/material';

interface SwitchProps {
  isChecked?: boolean;
  color?: string;
  onChange?: MuiSwitchProps['onChange'];
  title?: string;
}

export const Switch = ({
  isChecked,
  onChange,
  color = 'primary.main',
  title = '',
}: SwitchProps) => {
  const label = { inputProps: { 'aria-label': title } };

  return (
    <MuiSwitch
      {...label}
      onClick={e => e.stopPropagation()}
      checked={isChecked}
      sx={{
        color,
        '& .MuiSwitch-switchBase.Mui-checked': {
          color,
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: color,
        },
      }}
      onChange={onChange}
    />
  );
};
